import { getIdOrNull, requestWithPromise } from '..'
import { HttpMethods, makeQueryString } from '../apiHelper'
import apiClient from './apiClient'

export const getSchoolPermissions = (user, parameters) => {
  return requestWithPromise(
    `/api/school-permissions${makeQueryString(parameters)}`,
    HttpMethods.GET,
    null,
    user
  )
}

export const createSchoolPermission = (schoolPermission, user) => {
  return apiClient.post(user, 'api/school-permissions', schoolPermission.toRequestBody())
}

export const deleteSchoolPermission = (schoolPermission, user) => {
  return apiClient.delete(user, `api/school-permissions/${getIdOrNull(schoolPermission)}`)
}

export const modifySchoolPermission = (schoolPermission, user) => {
  return apiClient.patch(user, `api/school-permissions/${getIdOrNull(schoolPermission)}`, schoolPermission.toRequestBody())
}
